import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire de rejet d'une demande d'approbation
 * (`POST /ApprovalRequests/{id}/reject`, guide §6.8) — motif obligatoire.
 * Factory mémoïsée au niveau composant sur la langue courante.
 */
export const createRejectApprovalSchema = () =>
  z.object({
    rejectionReason: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
  });

export type RejectApprovalFormValues = z.infer<
  ReturnType<typeof createRejectApprovalSchema>
>;
